// extracted by mini-css-extract-plugin
export var button = "styles-module__button___kyKI2";
export var lowerButtons = "styles-module__lowerButtons___AWpO2";
export var next = "styles-module__next___Mbl3H";
export var previous = "styles-module__previous___khkDJ";
export var slickCarousel = "styles-module__slickCarousel___DO8vM";